const vanityRoutes = [
  {
    path: "/BRETT",
    redirect:
      "/landing-page/homeschool?couponCode=BRETT35&utm_medium=ads&utm_source=paid_podcast&utm_campaign=paid-podcast-BrettCooper",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/NOMADIC",
    redirect:
      "/online-classes/popular?couponCode=NOMADIC35&utm_medium=ads&utm_source=paid_instagram&utm_campaign=paid-influencer-NomadicMovement",
    isTranslated: true,
  },
  {
    path: "/AE",
    redirect:
      "/online-classes/popular?couponCode=AE&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-AnnieElise",
    isTranslated: true,
  },
  {
    path: "/UNPLANNED",
    redirect:
      "online-classes/popular?couponCode=UNPLANNED&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-UnplannedPodcast",
    isTranslated: true,
  },
  {
    path: "/PAKMAN",
    redirect:
      "online-classes/popular?couponCode=PAKMAN&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-Pakman",
    isTranslated: true,
  },
  {
    path: "/HUMANS",
    redirect:
      "online-classes/humans?couponCode=HUMANS&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-RaisingGoodHumans",
    isTranslated: true,
  },
  {
    path: "/LEGENDS",
    redirect:
      "online-classes/legends?couponCode=LEGENDS&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-MythandLegends",
    isTranslated: true,
  },
  {
    path: "/CREEPY",
    redirect:
      "online-classes/creepy?couponCode=CREEPY&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-Sinisterhood",
    isTranslated: true,
  },
  {
    path: "/STOLEN",
    redirect:
      "online-classes/stolen?couponCode=STOLEN&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-StolenLivesTrueCrime",
    isTranslated: true,
  },
  {
    path: "/GHOST",
    redirect:
      "online-classes/ghost?couponCode=GHOST&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-RealGhostStoriesOnline",
    isTranslated: true,
  },
  {
    path: "/MOMDAD",
    redirect:
      "online-classes/momdad?couponCode=MOMDAD&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-YourMomandDad",
    isTranslated: true,
  },
  {
    path: "/TUTORHELP",
    redirect:
      "tutoring?couponCode=TUTORING20&utm_medium=ads&utm_source=newsletter&utm_campaign=paid-newsletter-PeachJar",
    isTranslated: true,
  },
  {
    path: "/CAMPS",
    redirect:
      "online-classes/spring-camps?couponCode=CAMPS20&utm_medium=ads&utm_source=newsletter&utm_campaign=paid-newsletter-PeachJar",
    isTranslated: true,
  },
  {
    path: "/SUMMERCAMP",
    redirect:
      "online-classes/summer-camps?couponCode=CAMPS20&utm_medium=ads&utm_source=newsletter&utm_campaign=paid-newsletter-PeachJar",
    isTranslated: true,
  },
  {
    path: "/WARROOM",
    redirect:
      "online-classes/popular?couponCode=WARROOM&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-PoliticsWarroom",
    isTranslated: true,
  },
  {
    path: "/KOSER",
    redirect:
      "/landing-page/courses?couponCode=KOSER35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-PaigeKoser",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/PAIGEKOSER",
    redirect:
      "/landing-page/courses?couponCode=KOSER35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-PaigeKoser",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/KAMRY",
    redirect:
      "online-classes/popular?couponCode=KAMRY20&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-KamryVincent",
    isTranslated: true,
  },
  {
    path: "/LITTLEFENDERS",
    redirect:
      "online-classes/popular?couponCode=LITTLEFENDERS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-LittleFenders",
    isTranslated: true,
  },
  {
    path: "/TWINS",
    redirect:
      "join-membership?couponCode=START20&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-TwinsbytheBeach",
    isTranslated: true,
  },
  {
    path: "/EMMASEA",
    redirect:
      "join-membership?couponCode=START20&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-emmaseabourn",
    isTranslated: true,
  },
  {
    path: "/CHELSEA",
    redirect:
      "/landing-page/courses?couponCode=CHELSEA35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-ChelseaDyanTuran",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/TWINSBYTHEBEACH",
    redirect:
      "/landing-page/courses?couponCode=TWINS20&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-TwinsbytheBeach",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/HAPPYCARAVAN",
    redirect:
      "/landing-page/courses?couponCode=HAPPYCARAVAN&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-HappyCaravan",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/BETH",
    redirect:
      "/landing-page/homeschool?couponCode=BETH30&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-BethGriffin",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/MARYHANNA",
    redirect:
      "/landing-page/homeschool?couponCode=MARYHANNA30&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-MaryHannaWilson",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/ROOTS",
    redirect:
      "/landing-page/homeschool?couponCode=KAYCEE30&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-rootsacademyhs",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/TERESA",
    redirect:
      "/landing-page/homeschool?couponCode=TERESA30&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-TeresaAndLittles",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/ANDREA",
    redirect:
      "/landing-page/homeschool?couponCode=ANDREA30&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-LittleRedSchoolhouse",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/GRACE",
    redirect:
      "/landing-page/homeschool?couponCode=GRACE30&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-homeschoolingforall",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/RAVEN",
    redirect:
      "/landing-page/courses?couponCode=RAVEN20&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-RavenKramer",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/DMA",
    redirect:
      "/landing-page/courses?couponCode=DMA&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-DMA",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/WCN",
    redirect:
      "/landing-page/courses?couponCode=WCN&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-WCN",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/MADRE",
    redirect:
      "/landing-page/courses?couponCode=MADRE35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-EmilyDeLaTorre",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/LEAFANDLEARN",
    redirect:
      "/landing-page/courses?couponCode=LEAFANDLEARN&utm_medium=ads&utm_source=paid_influencer&utm_campaign=paid-influencer-LeafandLearn",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/HANNAH",
    redirect:
      "/landing-page/courses?couponCode=HANNAH35&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-HannahBurblaw",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/TYFFANY",
    redirect:
      "/landing-page/courses?couponCode=TYFFANY35&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-Tyffany",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/HOMEED",
    redirect:
      "/landing-page/courses?couponCode=HOMEED35&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-BigHomeEd",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/BRITTNEY",
    redirect:
      "/landing-page/courses?couponCode=BRITTNEY35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-BrittneyNolte",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/MCKENZIE",
    redirect:
      "/landing-page/courses?couponCode=MCKENZIE35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-MckenzieStaheli",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/CHIPPS",
    redirect:
      "/landing-page/courses?couponCode=CHIPPS2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_JeremyJennaChips",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/FAMILYFUNPACK",
    redirect:
      "/landing-page/courses?couponCode=KRISTINE35&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-FamilyFunPack",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/CARLY",
    redirect:
      "/landing-page/courses?couponCode=CARLY35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-CarlyHamaguchi",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/BEYERLE",
    redirect:
      "/landing-page/courses?couponCode=BEYERLE35&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-RachelBeyerle",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/ANGEL",
    redirect:
      "/landing-page/courses?couponCode=ANGEL35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-AngelRoseTurner",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/TIFFANY",
    redirect:
      "/landing-page/courses?couponCode=TIFFANY35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-TiffanyIshiguro",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/ERIN",
    redirect:
      "/landing-page/courses?couponCode=ERIN35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-ErinPaz",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/STANTON",
    redirect:
      "/landing-page/courses?couponCode=STANTON35&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-AmandaStanton",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/SHANNAN",
    redirect:
      "/online-classes/popular?couponCode=SHANNAN&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer-FaithfullyShannan",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/TAYLOR",
    redirect:
      "/landing-page/courses?couponCode=TAYLOR2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_TaylorMoran",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/EMILY",
    redirect:
      "/landing-page/courses?couponCode=EMILY2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_EmilyDeLaTorre",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/KOSER",
    redirect:
      "/landing-page/courses?couponCode=KOSER39&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-PaigeKoser",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/KAMRY",
    redirect:
      "/landing-page/courses?couponCode=KAMRY39&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-KamryVincent",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/CHRISSY",
    redirect:
      "/landing-page/courses?couponCode=CHRISSY39&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-ChrissyHorton",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/MELISSA",
    redirect:
      "/landing-page/courses?couponCode=MELISSA39&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-MelissaFerguson",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/GILMARTIN",
    redirect:
      "/landing-page/courses?couponCode=GILMARTIN39&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-AlexisGilmartin",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/KRISTIANA",
    redirect:
      "/landing-page/courses?couponCode=KRISTIANA39&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-AlexisKristiana",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/DEAL",
    redirect:
      "/landing-page/courses?couponCode=DEAL39&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-BrandonDeal",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/BEDTIME",
    redirect:
      "/landing-page/courses?couponCode=BEDTIME&utm_medium=ads&utm_source=podcast&utm_campaign=paid-podcast-BedtimeHistory",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/KAREN",
    redirect:
      "/landing-page/courses?couponCode=KAREN35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-KarenEdwards",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/NICOLE",
    redirect:
      "/landing-page/courses?couponCode=NICOLE30&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-NicoleShiffler",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/ANDI",
    redirect:
      "/landing-page/courses?couponCode=ANDI35&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-AndiPutt",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/TRAVELMAD",
    redirect:
      "/landing-page/courses?couponCode=TRAVELMAD&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer-TravelMadMum",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/angelrose",
    redirect:
      "/landing-page/courses?couponCode=ANGEL50&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_AngelRoseTurner",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/kimberly",
    redirect:
      "/landing-page/courses?couponCode=KIMBERLY50&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_KimberlyAlon",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/Groski",
    redirect:
      "/landing-page/courses?couponCode=GORSKI50&utm_medium=ads&utm_source=tiktok&utm_campaign=paid-influencer_RobGorski",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/Love",
    redirect:
      "/landing-page/courses?couponCode=LOVE50&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_AshleyBoltz",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/SHANNON",
    redirect:
      "/landing-page/courses?couponCode=SHANNON2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_ShannonLaNier",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/OLIVIA",
    redirect:
      "/landing-page/courses?couponCode=OLIVIA2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_OliviaBliss",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/ALEXIS",
    redirect:
      "/landing-page/courses?couponCode=ALEXIS2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_AlexisGilmartin",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/TERAN",
    redirect:
      "/landing-page/courses?couponCode=TERAN2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_TeranSands",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/ASHLEY",
    redirect:
      "/landing-page/courses?couponCode=ASHLEY2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_AshleyBoltz",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/ALEX",
    redirect:
      "/landing-page/courses?couponCode=ALEX2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_AlexFaafetai",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/ELKEY",
    redirect:
      "/landing-page/courses?couponCode=ELKEY2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_ElkeyZandstra",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/RACHEL",
    redirect:
      "/landing-page/courses?couponCode=RACHEL2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_RachelBeyerle",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/DAYNA",
    redirect:
      "/landing-page/courses?couponCode=DAYNA2MONTHS&utm_medium=ads&utm_source=instagram&utm_campaign=paid-influencer_DaynaChildress",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/showcase",
    redirect: "/campaigns/music-showcase",
    isTranslated: true,
    isExternal: true,
  },
  {
    path: "/OMS",
    redirect:
      "/campaigns/music-showcase?utm_medium=organic&utm_source=facebook&utm_campaign=KimonSpotlight",
    isTranslated: true,
    isExternal: true,
  },
];

export default vanityRoutes;
